import { z } from 'zod';

export const walletSchema = z.looseObject({
	// What the user may spend right now: the org's pool, capped by the user's own monthly limit.
	companyCredits: z.number(),
	contactCredits: z.number(),
	companyUsed: z.number(),
	contactUsed: z.number(),
	companyLimit: z.number().nullable(),
	contactLimit: z.number().nullable(),
	companyQuota: z.number(),
	contactQuota: z.number(),
});
